export enum LoginFormKeys {
    Email = 'login-email',
}
